export const apiPath = '/v2/travels';
const actionType = 'TRAVELS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
